module.exports = __webpack_public_path__ + "media/8.27ed4741.mp3";